
import {ClientInfoLS_Key, Events_Clients_Details, Events_Clients_Details_tempKey} from './index'


//return   array of type  {eventId, eventName, events:[ sameEventDifferentVenue type ]}
// sameEventDifferentVenue type is array of object with same eventId, but diffent venues
export const formatResponseForAvailableEvents = (venues) => {

    try{

        console.log(venues, "venues")

   
    let formattedData={};
    for (const venue of venues) {
        const venueName = venue.name;
        const venueId = venue.venueId;

        for (let event of venue.events) {
            if(event.inventories.length==0)continue;

            console.log(event, "event")
            event = { ...event, venueName, venueId };
            const eventId = event.id;
            const eventName = event.name;
            console.log("t/f",formattedData.hasOwnProperty(eventId))
            console.log("id",eventId)
            console.log("Name",eventName)
            if (formattedData.hasOwnProperty(eventId)) {

                if (formattedData[eventId].eventName != eventName) {
                    console.log("throwing error")
                    throw new Error("Inconsistent Data")
                }
                else {
                    console.log("2")
                    formattedData[eventId].events.push(event);
                }


            }
            else {
                console.log("3")
                formattedData[eventId] = { eventName, events: [event] };
            }
            console.log(formattedData,"formattedData")
        }



        const res = [];
        for (const [key, value] of Object.entries(formattedData)) {
            res.push({ ...value, eventId: key });
        }
        console.log(res,"formattedData final")
        return res;
    }
    }
    catch(err)
    {
        console.log("print error",err)
        throw new Error(err)
    }

}


export const isFirstReservation=()=>{
    if(localStorage.getItem(ClientInfoLS_Key) && localStorage.getItem(ClientInfoLS_Key)!='' && localStorage.getItem(ClientInfoLS_Key)!="null" ){
        return false;
    }

    if(localStorage.getItem(Events_Clients_Details_tempKey) && localStorage.getItem(Events_Clients_Details_tempKey)!="" && localStorage.getItem(Events_Clients_Details_tempKey)!="null"){
        const clientsDetails= JSON.parse(localStorage.getItem(Events_Clients_Details_tempKey));
        ["firstName","lastName","email","phoneNumber"].forEach((key)=>{
            if(!clientsDetails.hasOwnProperty(key)){
                return true;
            }
        })
        return false;
    }

    return true;
}

//Todo
// later uncomment it
// export const neccessaryFieldsForReservationPresent =(oldReservation)=>{

//     // if( oldReservation.hasOwnProperty("first_name")&&
//     //     oldReservation.hasOwnProperty("last_name")&&
//     //     oldReservation.hasOwnProperty("email") &&
//     //     oldReservation.hasOwnProperty("phone_number")&&
//     //     oldReservation.hasOwnProperty("phone_number")!="" )
//     //     return true;
//     // else{
//     //     return false;
//     // }


    
//         return true; // later remove this line;
// }

 


export const getClientDetailsForEventCreation=()=>{
        const Current_Logged_In_Guest_Details= localStorage.getItem("Set_Current_Logged_In_Guest_Details");
        
        return {
            firstName: Current_Logged_In_Guest_Details[0].guestProfile.firstName,
            lastName: Current_Logged_In_Guest_Details[0].guestProfile.lastName,
            phoneNumber: Current_Logged_In_Guest_Details[0].guestProfile.phoneNumber,
            email: Current_Logged_In_Guest_Details[0].guestProfile.email
        }
} 


